import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { FoyerService,StateService, TagTiersService,DossierService } from '../../../../../services'
import { ActivatedRoute, Router } from "@angular/router"
import {
	Observable,
	BehaviorSubject,	
} from "rxjs"
const KEY = 'dossier-tab-foyer'
@Component({
	selector: 'atyl-dossier-foyer',
	templateUrl: './dossier-foyer.component.html',
	styleUrls: ['./dossier-foyer.component.scss']
})
@Stringable({
	path: 'views/pages/recherche/tabs/foyer',
	key: KEY,
})
export class DossierFoyerComponent implements OnInit {

	@Input() foyers: any
	@Input() relations: any
	
	@Input() currentTier: any
	@Output() tierClicked = new EventEmitter();
	@StringableValues(KEY) strings: any
	listeFoyers: any = [];

    tierRedresh:any;
	changeTiers:BehaviorSubject<number>=new BehaviorSubject<number>(0);

	@Input() loaded:boolean=true;
	
	loading: boolean=false;
	groups: Object = {}
    
	@Input() events: Observable<void>
	eventsSubscription:any;
	
	sexeLabel:any[]=['<i class="la la-mars" title="Masculin"></i>',
					'<i class="la la-venus" title="Féminin"></i>',
					'<i class="la la-transgender" title="Indéterminé"></i>'
				];
	
	constructor(
		private foyerService: FoyerService,
		private dossierService: DossierService,
		private changeDetector: ChangeDetectorRef,
		private router: Router,
        private activatedRoute: ActivatedRoute,
		private stateService: StateService,
		private tagTiersService: TagTiersService,
	) { }

	ngOnInit() {
        console.log("foyers",this.foyers,this.loaded);
		console.log("AAAA relations", {
			relations: this.relations
		})
		
		this.eventsSubscription = this.events.subscribe((data: any) =>{
			             console.log("DossierFoyerComponent evnet",data,this.relations);
						let aDossier:any[] =[];
						let tos:any ={};
						
						if (this.relations!=undefined && this.relations.to!=undefined   && this.relations.to.length > 0) {
							
							for(let i:number=0;i<this.relations.to.length;i++) {
								let relation:any=this.relations.to[i];
								//console.log("DossierFoyerComponent to id",relation.tiers);
								if (relation.tiers!=undefined && relation.tiers.dossierID!=undefined
									 && relation.tiers.statistiques==undefined) {
									aDossier.push(relation.tiers.dossierID);
									tos[relation.tiers.dossierID+""]={index: i, destination:"to"};
							     }
								if (relation.tiers_associate!=undefined && relation.tiers_associate.length>0) {
							 		let asso:any[]=relation.tiers_associate;
									for(let j:number=0;j<asso.length;j++) {
										if (asso[j].dossierID!=undefined
											 && asso[j].statistiques==undefined) {
											aDossier.push(asso[j].dossierID);
											tos[asso[j].dossierID+""]={index: i, destination:"to",asso: j};
										}
								    }
							 	 
								 }
							}
						}
						
						if (this.relations!=undefined && this.relations.from!=undefined   && this.relations.from.length > 0) {
													
							for(let i:number=0;i<this.relations.from.length;i++) {
								let relation:any=this.relations.from[i];
								//console.log("DossierFoyerComponent from ",relation.tiers);
								if (relation.tiers!=undefined && relation.tiers.dossierID!=undefined
									 && relation.tiers.statistiques==undefined) {
									aDossier.push(relation.tiers.dossierID);
									tos[relation.tiers.dossierID+""]={index: i, destination:"from"};
								}
								
								if (relation.tiers_associate!=undefined && relation.tiers_associate.length>0) {
						 		let asso:any[]=relation.tiers_associate;
								for(let j:number=0;j<asso.length;j++) {
									if (asso[j].dossierID!=undefined 
										&& asso[j].statistiques==undefined) {
										aDossier.push(asso[j].dossierID);
										tos[asso[j].dossierID+""]={index: i, destination:"from",asso: j};
									}
							    }
						 	 
							 }
								
							}
						}
						console.log("DossierFoyerComponent evnet",aDossier,tos);
						if (aDossier.length>0) {
							this.dossierService.getStatistiqueDossierList(aDossier).subscribe((res: JSONRpcResponse) =>{
								if (res.result &&res.result.length>0) {
									console.log("DossierFoyerComponent stats",res.result);
									res.result.forEach((stats: any) => {
										//console.log("DossierFoyerComponent stats before",stats);
										if (tos[stats.ID]!=undefined) {
											//console.log("DossierFoyerComponent stats tos",tos[stats.ID]);
											
											if (tos[stats.ID].asso==undefined && tos[stats.ID].destination=="to" && this.relations.to[tos[stats.ID].index]!=undefined 
												&& this.relations.to[tos[stats.ID].index].tiers!=undefined) {
												//	console.log("DossierFoyerComponent stats to",stats.statistiques);	
												this.relations.to[tos[stats.ID].index].tiers.statistiques=stats.statistiques;
											}
											
											if (tos[stats.ID].asso==undefined && tos[stats.ID].destination=="from" && this.relations.from[tos[stats.ID].index]!=undefined 
												&& this.relations.from[tos[stats.ID].index].tiers!=undefined) {
												//	console.log("DossierFoyerComponent stats from",stats.statistiques);
												this.relations.from[tos[stats.ID].index].tiers.statistiques=stats.statistiques;
											}
											
											
											if (tos[stats.ID].asso!=undefined && tos[stats.ID].destination=="to" && this.relations.to[tos[stats.ID].index]!=undefined 
												   && this.relations.to[tos[stats.ID].index].tiers_associate[tos[stats.ID].asso]!=undefined
													) {
												//		console.log("DossierFoyerComponent stats to",stats.statistiques);	
													this.relations.to[tos[stats.ID].index].tiers_associate[tos[stats.ID].asso].statistiques=stats.statistiques;
											}
											
											if (tos[stats.ID].asso!=undefined && tos[stats.ID].destination=="from" && this.relations.from[tos[stats.ID].index]!=undefined 
													   && this.relations.from[tos[stats.ID].index].tiers_associate[tos[stats.ID].asso]!=undefined
														) {
													//console.log("DossierFoyerComponent stats from",stats.statistiques);	
													this.relations.from[tos[stats.ID].index].tiers_associate[tos[stats.ID].asso].statistiques=stats.statistiques;
											}
											
											
										}
											
									});
									
									
									console.log("DossierFoyerComponent stats relation",this.relations);
									this.generateGroup();
									this.changeTiers.next(0);
									this.changeDetector.detectChanges();
								}
								});
						}
								
		})
		
		
		/*this.relations.to.map(tier => {
			tier = this.formatAgeTiers(tier);
		});
		this.relations.from.map(tier => {
			tier = this.formatAgeTiers(tier);
		});*/
		
		this.stateService.dossier.subscribe((dossier) => {
		          console.log('DossierFoyerComponent load refresh',dossier)
				  this.generateGroup()
		})
		
		/*if (this.loading)
			this.generateGroup()*/
	}
	
	ngOnDestroy() {
	if (this.eventsSubscription!=undefined) {
		
		  
		 
	 		this.eventsSubscription.unsubscribe();
	 	}
	       
	}

	generateGroup() {
		this.loading=true;
		this.groups={};
		let flatRelations = [...this.relations.from, ...this.relations.to]

		console.log("flatRelation",flatRelations);
		for (var relation of flatRelations) {
			if (!relation.relation.groupe) {
				relation.relation.groupe = {
					ID: -1,
					key: "liaison",
					libelle: "Liaison(s)"
				}
			}
			relation = this.formatAgeTiers(relation);
			//this.getTagsRelations(relation);
			const relationGroupe = relation.relation.groupe
			
			if (this.groups[relationGroupe.key]) {
				this.groups[relationGroupe.key].children.push(relation)
			} else {
				this.groups[relationGroupe.key] = {
					name: relationGroupe.libelle,
					key: relationGroupe.key,
					order: Object.keys(this.groups).length,
					children: [relation],
					cards:{}
				}
				
					
			}
			const relationType=relation.relation;
			if (this.groups[relationGroupe.key].cards[relationType.key+relationType.to]==undefined) {
				this.groups[relationGroupe.key].cards[relationType.key+relationType.to]={
					relation: relationType,
					children: []
				};
			}
			this.groups[relationGroupe.key].cards[relationType.key+relationType.to].children.push(relation);
			
		}

		console.log("this.groups",this.groups)
		this.loading=false;
	}

	generateListeFoyers(): any {
       /*
		this.foyers.forEach((foyer: any) => {
			console.log(foyer)
			let newFoyer = {
				ID: foyer.ID,
				creationdate: foyer.creationdate,
				etat: foyer.etat,
				libelle: foyer.libelle,
				tiers: []
			}
			foyer.tiers.forEach((tier: any) => {
				this.foyerService.getRelations(this.currentTier.ID, tier.ID).subscribe((res: JSONRpcResponse) => {
					if (res) {
						tier.relations = res.result
						newFoyer.tiers.push(tier)
					}
				}, (err: any) => {
					console.error(err)
				}, () => {
					if (this.listeFoyers.indexOf(newFoyer) === -1) {
						this.listeFoyers.push(newFoyer)
					}
					this.changeDetector.detectChanges()
				})
			})
		})
		*/
	}
	foyerTierClicked(event: any,tiers:any) {
        this.tierClicked.emit(tiers);
       /* console.log("foyerTierClicked",tiers);
		 this.router.navigate([`/home/dossier/${this.dossier.type}/${tiers.dossierID}`], {
            relativeTo: this.activatedRoute,
        })*/
		/*console.log("foyerTierClicked",tiers)
		
		let refreshAction:any = {
		                    type:"personne",
		                    data:{
		                      init:tiers.dossierID
		                    }
		                };
		this.stateService.updateRefresh(refreshAction);
		this.router.navigate([`/home/dossier/${tiers.type}/${tiers.dossierID}`], {
		            relativeTo: this.activatedRoute		,
						queryParams: {
			                init: tiers.dossierID
			            }
		 })
		 */
		
	}
	typify(type: string) {
		switch (type) {
			case 'USAGER':
				return 'Adulte'
			case 'ENFANT':
				return 'Enfant'
			default:
				return type
		}
	}
	
	actionUpdated(event: any,tiers:any) {
		console.log('DossierPageFoyerComponent action',event,tiers)
		this.changeTiers.next(tiers.dossierID);
	
	}

	formatAgeTiers(tier,isTiersAsso = false){
		var currentTiers = tier.tiers != undefined? tier.tiers: tier
		if(currentTiers.physique)
			currentTiers.AGE.formated = this.getAgeFormated(currentTiers)
		if(!isTiersAsso && tier.tiers_associate != undefined && tier.tiers_associate.length > 0){
			tier.tiers_associate.forEach(tiersAsso => {
				tiersAsso = this.formatAgeTiers(tiersAsso,true);
			});
		}
		return tier;
	}

	getAgeFormated(tiers){
		var tiersAge: string = '';
		if(tiers.AGE.y > 0){
			tiersAge += tiers.AGE.y;
			tiersAge += tiers.AGE.y > 1? " ans": " an";
		}
		if(tiers.AGE.m > 0){
			if(tiersAge.length>0)
				tiersAge += " "
			tiersAge += tiers.AGE.m +" mois";
		}
		if(tiers.AGE.d > 0){
			if(tiersAge.length>0)
				tiersAge += " "
			tiersAge += tiers.AGE.d;
			tiersAge += tiers.AGE.d > 1 ? " jours": " jour";
		}
		return tiersAge;
	}

	getTagsRelations(rel){
		console.log("___rel",rel)
		this.tagTiersService.getTiersTags(rel.tiers.ID).subscribe(res=>{
			rel.tags = res.result;
		})
		rel.tiers_associate.forEach(asso => {
			console.log("___asso",asso)
			this.tagTiersService.getTiersTags(asso.ID).subscribe(res=>{
				console.log("___asso2",asso)
				asso.tags = res.result;
			})
		});
	}

	hexToRgbA(hex: string, alpha: any = 200) {
		let color: any
		let newAlpha = Number.parseInt(alpha, 10)

		if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
			color = hex.substring(1).split('')
			if (color.length == 3) {
				color = [color[0], color[0], color[1], color[1], color[2], color[2]]
			}
			color = '0x' + color.join('')
			return 'rgba(' + [(color >> 16) & 255, (color >> 8) & 255, color & 255].join(',') + ',' + newAlpha / 255 + ')'
		}
	}
	
	getColCard(cards:any) {
		let nxCol:number=12;
		let keys:string[]= Object.keys(cards);
		
		let col:string="col-6";
		if (keys.length>0)
			col="col-"+(nxCol/keys.length);
		
		return col;
	}
	
	getRelationIcon(relation:any) {
		console.log("DossierFoyerComponent getRelationIcon",relation)
		return (relation.icone!=undefined) ? relation.icone : null;
	}
	
	getRelationColor(relation: any, type:string="background"): any {
		console.log("DossierFoyerComponent getRelationColor",relation)
		let style:any={};
		if (relation.rgb!=undefined)
			style[type]="rgba("+ relation.rgb.r +","+ relation.rgb.g +","+ relation.rgb.b +","+ relation.rgb.a+")";
		return style;
	}
	
	getRelationColorAttibute(relation: any, type:string="background"): any {
		
		let style:any={};
		if (relation.rgb!=undefined)
			style[type]="rgba("+ relation.rgb.r +","+ relation.rgb.g +","+ relation.rgb.b +","+ relation.rgb.a+")";
		
		let st:string="";
		if (style[type]!=undefined)
			st=type+":"+style[type] +" !important;";
		return st;
	}

}
